module.exports = __webpack_public_path__ + "img/rating-smiley-1.c42c2d81.svg";